import BaseAPI from '../base'

function connect(cafe_id) {
    return BaseAPI.post(`moeco/connect/${cafe_id}`);
}

function disconnect(cafe_id) {
     return BaseAPI.post(`moeco/disconnect/${cafe_id}`);
}

export default {
    connect,
    disconnect
}